import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Japan = () => {
    return <SharedDocumentsComponent permissionId="41" path="Japão" />
}